import produce from 'immer';

import { COUNCIL_RECEIVED, COUNCILS_RECEIVED } from 'constants/actions';

export var INITIAL_STATE = {
  items: [],
  councilError: false,
  councilsError: false
};

export const councils = produce((draft, action) => {
  switch (action.type) {
    case COUNCILS_RECEIVED:
      draft.items = action.value;
      return draft;

    case COUNCIL_RECEIVED: {
      let index = draft.items.findIndex(({ id }) => id === action.value.id);

      ~index ? (draft.items[index] = action.value) : draft.items.push(action.value);
      return draft;
    }

    default:
      return draft;
  }
}, INITIAL_STATE);

export default councils;
